import { render, staticRenderFns } from "./HomeBoxCreateAccount.vue?vue&type=template&id=3f5e12ce"
import script from "./HomeBoxCreateAccount.vue?vue&type=script&lang=js"
export * from "./HomeBoxCreateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports